import { all, takeLatest, put, select } from 'redux-saga/effects';

import { setCookie } from '@coconut/services/cookies';

import {
  types,
  getQuestionListCurrentStage,
  questionListIncrementCookieSuccess,
  getChatCurrentStage,
  chatIncrementCookieSuccess,
} from '@coconut/services/redux/tutorial';

import {
  QUESTION_LIST_TUTORIAL_STAGE,
  CHAT_TUTORIAL_STAGE,
} from '@coconut/constants/cookieName';

function* questionListIncrementCookieFlow() {
  const oldStage = yield select(getQuestionListCurrentStage);
  const currentStage = oldStage + 1;
  setCookie(QUESTION_LIST_TUTORIAL_STAGE, currentStage);

  yield put(questionListIncrementCookieSuccess(currentStage));
}

function* chatIncrementCookieFlow() {
  const oldStage = yield select(getChatCurrentStage);
  const currentStage = oldStage + 1;
  setCookie(CHAT_TUTORIAL_STAGE, currentStage);

  yield put(chatIncrementCookieSuccess(currentStage));
}

function* skipChatIncrementCookieFlow(action) {
  const { currentStage } = action.payload;
  setCookie(CHAT_TUTORIAL_STAGE, currentStage);
}

export default function* () {
  yield all([
    takeLatest(
      types.QUESTION_LIST_INCREMENT_COOKIE,
      questionListIncrementCookieFlow
    ),
    takeLatest(types.CHAT_INCREMENT_COOKIE, chatIncrementCookieFlow),
    takeLatest(types.SKIP_CHAT_INCREMENT_COOKIE, skipChatIncrementCookieFlow),
  ]);
}



// WEBPACK FOOTER //
// ./src/services/sagas/tutorial.js